import React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import { ListItem, ListItemSegment } from 'components/ListItem'
import { match } from 'utils/patternMatchUtil'
import formatCurrency from 'utils/formatCurrency'
import Avatar from 'components/Avatar'
import './styles.sass'

/* eslint-disable react/display-name */

const EventReason = observer(function EventReason ({ event }) {
  if (event.reason) {
    return (
      <div className="event-reason">
        {event.reason}
      </div>
    )
  }

  if (event.eventType === 'AMENDED') {
    return (
      event.amendment.description.trim() &&
        <div className="event-reason">
          {event.amendment.description}
        </div>
    )
  }

  return null
})

const Price = ({ value, includeSymbol }) => (
  <span className={cx('event-price', value < 0 ? 'is-negative' : 'is-positive')}>
    {value > 0 && includeSymbol ? '+' : ''}
    {formatCurrency(value)}
  </span>
)

const EventDescription = observer(function EventDescription ({ event }) {
  return match(event.eventType, {
    AMENDED: () => (
      <div className="event-description">
        Amendment created
        {event.previousQuote.providerCutAmount !== event.newQuote.providerCutAmount &&
          <span className="event-description__details">
            &nbsp;
            &mdash;
            &nbsp;
            <Price value={event.newQuote.providerCutAmount - event.previousQuote.providerCutAmount} />
          </span>
        }
      </div>
    ),
    UNCLAIMED: () => event.rebound
      ? (
        <div className="event-description">Transmitted back to the pool</div>
      )
      : (
        <div className="event-description">Transmitted to the pool</div>
      ),
    REOPENED: () => (
      <div className="event-description">Reopened</div>
    ),
    TRANSFERRED: () => (
      <div className="event-description">
        Transferred from <strong>{event.previousProvider.displayName}</strong> to <strong>{event.newProvider.displayName}</strong>
      </div>
    ),
    CLAIMED: () => (
      <div className="event-description">
        Picked up
      </div>
    ),
    UPDATED: () => (
      <div className="event-description">
        Updated
        {event.previousQuote.total !== event.newQuote.total &&
          <span className="event-description__details">
            &nbsp;
            &mdash;
            &nbsp;
            <Price value={event.newQuote.total - event.previousQuote.total} />
          </span>
        }
      </div>
    ),
    CLOSED: () => (
      <div className="event-description">
        Closed by <strong>{event.triggeredBy.displayName}</strong>
      </div>
    ),
    [match.DEFAULT]: () => (
      <div className="event-description">{event.description}</div>
    )
  })
})

export default observer(function JobEvent ({ event }) {
  return (
    <ListItem className="job-event" border>
      <ListItemSegment pad stretch>
        <p className="event__created">
          {event.dateCreated.format('L LT')}
        </p>
        <EventDescription event={event} />
        <div className="event-triggered-by" title={event.triggeredBy.detailedDisplayName}>
          <Avatar
            url={event.triggeredBy.avatar}
            fallback={event.triggeredBy.avatarFallback}
            size={16}
          />
          <div className="event-triggered-by__name">
            {event.triggeredBy.displayName}
          </div>
        </div>
        <EventReason event={event} />
      </ListItemSegment>
    </ListItem>
  )
})



// WEBPACK FOOTER //
// ./src/client/components/JobEvent/index.jsx